// Copyright ©️ 2026 eVolve MEP, LLC

import type { Ref } from 'react';

import { Card, type CardProps, Stack } from '@mantine/core';

export const DesktopLayoutCard = ({ children, ref, ...props }: CardProps & { ref?: Ref<HTMLDivElement> }) => (
  <Card ref={ref} px={16} py={12} shadow="sm" display="flex" h="100%" pos="relative" {...props}>
    <Stack gap={0} h="100%" flex={1}>
      {children}
    </Stack>
  </Card>
);
